import { StyleSheet, TextInput, View } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { Colors, Typography } from "../../styles";

interface Props {
  placeholder: string;
  onChange: (val: string) => void;
}

const SearchBar = ({ placeholder, onChange }: Props) => {
  return (
    <View style={styles.container}>
      <FontAwesome
        name="search"
        size={14}
        color={Colors.plum400}
        style={styles.icon}
      />
      <TextInput
        placeholder={placeholder}
        style={styles.input}
        placeholderTextColor={Colors.plum400}
        onChangeText={onChange}
        // autoCapitalize='sentences'
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...Typography.weightRegular,
    backgroundColor: Colors.plum700,
    borderRadius: 100,
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    marginRight: 8,
  },
  input: {
    ...Typography.weightRegular,
    flex: 1,
  },
});

export default SearchBar;
